import React, { useEffect, useRef } from "react";
import { Label, TextFieldWrap, WrapMessage } from "shared/TextField/styled";

const TextField = ({
  text,
  error,
  errorMessage,
  name,
  placeholder,
  reff,
  rows,
  cols,
  onChange,
  value,
  disabled,
  className,
  isAutoresize,
}) => {
  const ref = useRef();

  useEffect(() => {
    if (isAutoresize) {
      ref.current.style.height = "46px";
      ref.current.style.height = ref.current.scrollHeight + "px";
    }
  }, [value]);

  return (
    <>
      <TextFieldWrap error={error}>
        <Label error={error}>{text}</Label>
        <textarea
          className={className}
          ref={(e) => {
            ref.current = e;
            reff && reff(e);
          }}
          name={name}
          onChange={onChange}
          value={value}
          rows={rows}
          cols={cols}
          placeholder={placeholder}
          error={error}
          disabled={disabled}
        />
        {error && <WrapMessage>{errorMessage}</WrapMessage>}
      </TextFieldWrap>
    </>
  );
};

export default TextField;
